export type CategoryType = 'product' | 'order' | 'customer' | 'supplier' | 'employee' | 'ledger';

interface Category {
  name: CategoryType;
  title: string;
}

export const categoriesList: Category[] = [
  {
    name: 'product',
    title: 'Sản phẩm',
  },
  {
    name: 'order',
    title: 'Đơn hàng',
  },
  {
    name: 'customer',
    title: 'Khách hàng',
  },
  {
    name: 'supplier',
    title: 'Nhà cung cấp',
  },
  {
    name: 'employee',
    title: 'Nhân viên',
  },
  {
    name: 'ledger',
    title: 'Sổ cái',
  }
];
